import React from 'react';

import uuid from 'uuid';

import { StyledAdGroups } from './style/StyledAdGroups';

import NotFound from '../NotFound';

import DynamicComponent from '../../DynamicComponent';

const AdsGroups = ({ data, isLast }) => (
	<StyledAdGroups>
		<section>
			<h2>{data.title}</h2>
			<p>{data.content.text}</p>
		</section>

		{
			data.tables.length > 0 ? (
				<div className="content-1200">
					<div className="content-charts">
						{data.tables.map(table => (
							<DynamicComponent
								key={uuid.v4()}
								tag={table.type}
								data={table.data}
							/>
						))}
					</div>
				</div>
			) : (
				<section className="mt-4">
					<NotFound />
				</section>
				)
		}

		{!isLast ? <hr className="mt-4" /> : null}
	</StyledAdGroups>
);

export default AdsGroups;
